import React, { Component } from 'react'
import { Link } from 'react-router-dom'
// import { SecondaryButton } from './Button'
import Footer from './Footer'
import arrow from '../images/arrow.svg'

import Building from '../images/home/Building.svg'
import BuySell from '../images/home/BuySell.svg'
import Compass from '../images/home/Compass.svg'
import Confidence from '../images/home/Confidence.svg'
import Header from '../images/home/Header.svg'
//import Icon from '../images/home/Icon.svg'
// import Logo from '../images/home/Logo.svg'
import Map from '../images/home/Map.svg'
// import investmentReturn from '../images/home/investment-return.gif'
import investmentReturn from '../videos/return.mov'
import chart from '../videos/chart.mov'
// import calc from '../videos/calc.mov'
//import watchlist from '../videos/watchlist.mov'
import portfolio from '../videos/polarisportfolionoaudio.mov'
//import stars from '../images/home/Stars.png'


const H2 = props => (
  <h2 className="f2 blue mt2 mb3 messina-serif lh-title">{props.children}</h2>
)

const H6 = props => (
  <h6 className="f6 mv3">{props.children}</h6>
)

const P = props => {
  switch (props.color) {
    case 'white':
      return (<p className="f5 mv2 white">{props.children}</p>)
    case 'gray':
      return (<p className="f5 mv2 gray measure">{props.children}</p>)
    default:
      return (<p className="f5 mv2">{props.children}</p>)
  }
}

class Home extends Component {

  componentDidMount = () => {
    window.analytics.page()
  }

  render(){
    return (
      <div className="">

      

        {/* HEADER */}
        <section className="bg-baby-blue pv3-l">
          <div className="cf center mw9 flex-ns pv4-m pv3-l">
            <div className="fl w-100 w-50-ns pa4 ph5-m pr5-l pl4-l">
              <h1 className="blue messina-serif f1 lh-title mt0 mb3">Make Sound Investment Decisions</h1>
              <p className="f4 mb4 measure"><i><b>Want a more disciplined approach to investing?</b></i> The Polaris approach focuses on key drivers to calculate defensible valuations and identify projected higher than average returns. </p>
              <Link to="/pricing">
                <button className="link f4 br2 ph4 pv3 mb2 dib bg-white blue fw4 pointer b--none">Get started</button>
              </Link>
            </div>
            <div className="fl w-100 w-50-ns tc self-center-ns ph4 mb4">
              <img className="h6" src={Header} alt="map" />
            </div>
          </div>
        </section>

        {/* VALUE */}
        <section className="bg-white pv4 pv5-m pv4-l  ">
          <div className="cf center mw9 flex-ns">
            <div className="fl w-100 w-50-ns pa4 tc">
              <img className="" height="275" src={Map} alt="map" />
            </div>
            <div className="fl w-100 w-50-ns pa4 pb4 self-center-ns">
              <H2 className="blue">Simplicity Beats Complexity</H2>
              <p className="black measure"><i><b>Tired of confusing investment sites?</b>
              </i> Polaris' easy to use interface guides you towards above average stock market returns using a few key variables. Sleep well at night knowing you've made a thoughtful decision.</p>
            </div>
          </div>

          <div className="cf center mw9 pt5-m pt6-l flex-ns">
            <div className="fl w-100 w-50-ns pa4 tc">
              <img className="" height="275" src={BuySell} alt="map" />
            </div>
            <div className="fl w-100 w-50-ns pa4 pb4 self-center-ns">
              <H2 className="blue">Know When to Buy and Sell</H2>
              <p className="black measure"><i><b>Is panic or hype leading you to buy and sell at the wrong time? </b></i> 
               The investment plans you create will advise you when to buy, sell or hold a given stock thereby giving you the conviction to weather short term market fluctuations.</p>
            </div>
          </div>

          <div className="cf center mw9 pt5-m pt6-l flex-ns">
            <div className="fl w-100 w-50-ns pa4 tc">
              <img className="" height="275" src={Confidence} alt="map" />
            </div>
            <div className="fl w-100 w-50-ns pa4 self-center-ns">
              <H2 className="blue">Become a More Confident Investor</H2>
              <p className="black measure"><i><b>Wouldn't you like to know how to identify stocks with above average profit potential?</b></i> Check out our <a className="link blue" href={`https://www.youtube.com/watch?v=nnPLp8pimrw&list=PL2dQtklQds_vbjsZpFKfLxoESYItC8Xwo`} target="_blank">Featured Stocks </a>videos to see how to balance past facts with future possibilities.</p>
            </div>
          </div>
        </section>

        {/* FEATURES */}
        <section>
          <div className="center mw9 pv4 pt4-ns mb5-ns tc bb b--black-10">
            <img src={Compass} className="mt3 w2" alt="compass icon" />
            <h3 className="f2 blue messina-serif mv2">Polaris Tools</h3>
            <small className="black f5 db">See Features</small>
            <small className="db">
              <img src={arrow} alt="arrow" />
            </small>
          </div>

          <div id="feature" className="cf center mw9 pb4-ns pt4 flex-ns">
            <div className="fl w-100 w-50-ns ph4 tc">
              <video  className="shadow-custom br2 overflow-hidden mw6" width="100%" height="auto" autoPlay="autoPlay" loop controls={false}>
                <source src={investmentReturn} type="video/mp4" />
              </video>
            </div>
            <div className="fl w-100 w-50-ns ph4 pb4 self-center-ns">
              <H6>Theoretical and Practical Valuations</H6>
              <H2 className="blue">Know The Value</H2>
              <ul className="measure pa0 pl3">
                <li className="mb3">Diligently determine the value of a stock based on a few key financial and economic variables.</li>
                <li className="mb3">Compare a stock’s theoretical or academic value with a more practical value based on the stock’s current market price 
                ("wisdom of the crowds").</li>
                <li className="mb3">Maximize your wealth by investing in stocks whose potential return beats the market average (the S&P500)</li>
              </ul>
            </div>
          </div>

          <div id="feature" className="cf center mw9 pv5-ns flex-ns">
            <div className="fl w-100 w-50-ns ph4 tc">
              <video  className="shadow-custom br2 overflow-hidden mw6 " width="100%" height="auto" autoPlay="autoPlay" loop controls={false}>
                <source src={chart} type="video/mp4" />
              </video>
            </div>

            <div className="fl w-100 w-50-ns ph4 pb4 self-center-ns">
              <H6>Practical Buy/Sell Price Ranges</H6>
              <H2 className="blue">Know When To Act (Not React)</H2>
              <P>An Investment Plan for each stock provides straight foward recommendations as to when to buy, watch or sell a particular stock.</P>
            </div>
          </div>


          
         {/*  <div id="feature" className="cf center mw9 pv5-ns flex-ns">
            <div className="fl w-100 w-50-ns ph4 tc">
              <video  className="shadow-custom br2 overflow-hidden mw6 " width="100%" height="auto" autoPlay="autoPlay" loop controls={false}>
                <source src={calc} type="video/mp4" />
              </video>
            </div>
            <div className="fl w-100 w-50-ns ph4 pb4 self-center-ns">
              <H6>Investment Return Calculator</H6>
              <H2 className="blue">See Returns</H2>
              <P>Our handy Investment Return Calculator helps you determine how much money you could accumulate if you invested in a particular stock at the current price.</P>
            </div>
          </div> */}

          <div id="feature" className="cf center mw9 pv5-ns flex-ns">
            <div className="fl w-100 w-50-ns ph4 tc">
            <p> </p>
              <video  className="shadow-custom br2 overflow-hidden mw6 " width="100%" height="auto" autoPlay="autoPlay" loop controls={false}>
                <source src={portfolio} type="video/mp4" />
              </video>
            </div>
            <div className="fl w-100 w-50-ns ph4 pb4 self-center-ns">
              <H6>FREE Apps <a href="https://youtu.be/SaT9W_ELWqk?view_as=subscriber" target="_blank" rel="noopener noreferrer" className="blue link" onClick={this.closeMenu}> - Video</a></H6>
              <H2 className="blue">Build and Monitor Your Portfolio</H2>
              <P color="gray">Keep an eye on your investments.</P>
              <ul className="measure pa0 pl3">
                <li className="mb3">SP500 Analyzer App: Build a SP500 index-beating portfolio. Provides historical and real-time price data.</li>
                <li className="mb3">Portfolio Return App: Monitor your personal portfolio of stocks. Provides historical and real-time price data and comparison to SP500 index.</li>
                <li className="mb3">Polaris Valuation App: Calculate detailed valuations. Keep notes on the story behind the numbers. Intended for advanced users.</li>
                <li className="mb3">Polaris Trade Management App: Manage stock trading and cash. Provides a disciplined approach to buy low and sell high.</li>
                <li className="mb3">Stock Liquidation App: Used to raise a targeted amount of cash by identifying appropriate stocks to sell and then tracking order fulfillment.</li>
                <p align="center">
                <Link onClick={() => this.trackLinkClick()} to="https://www.dropbox.com/sh/wiguecridixzsz5/AADib8HQ1qD5PgxEJmlsSkJva?dl=0" target="_blank" >
                  <button className="link f4 br2 ph4 pv3 mb2 dib bg-blue white fw4 pointer b--none">Download</button>
                </Link>
                </p>
              </ul>
            </div>
          </div>

          <div id="feature" className="cf center mw9 pv5-ns flex-ns">
            <div className="fl w-100 w-50-ns ph4 tc">
            <iframe title="Polaris Overview" width="350" height="315" src= "https://www.youtube.com/embed/BaCw8xdnkM4"  frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
            <div className="fl w-100 w-50-ns ph4 pb4 self-center-ns">
              <H6>Quick Overview Video</H6>
              <H2 className="blue">Watch 4 minute Video</H2>
              <P></P>
            </div>
          </div>

        </section>

        {/* CTA FOOTER */}
        <section className="bg-peach">
          <div className="cf center mw9 flex-ns pv5-m ph5-l">
            <div className="fl w-100 w-50-ns pa4 pr0-ns pt5-ns">
              <h1 className="blue messina-serif f1 lh-title mt0 mb3">Become a better investor today</h1>
              <p className="white mb4 f4">Free 14-day free trial. Cancel anytime. The Portfolio Return App is yours to keep.</p>
              <Link to="/pricing">
                <button className="link f4 br2 ph4 pv3 mb2 dib bg-white blue fw4 pointer b--none">Get started</button>
              </Link>
            </div>
            <div className="fl w-100 w-50-ns pa4">
              <img src={Building} alt="building wealth"/>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home.js